import parse from "html-react-parser"
import Accordion from "./accordion-product/Accordion"
import CardProduct, { ICardProductProps } from "./card-product/CardProduct"
import "./PsychologySessionProducts.css"

export interface IPsychologySessionProductsProps {
  title: string
  subtitle?: string
  price: ICardProductProps["price"]
  linkTo: ICardProductProps["linkTo"]
  onClickBuyButton: () => void
}

export default function PsychologySessionProducts({
  title,
  subtitle,
  price,
  linkTo,
  onClickBuyButton
}: IPsychologySessionProductsProps) {
  return (
    <div className="psychology-session-products">
      <div className="psychology-session-products-content" id="PsychologySessionProductsContent">
        <div className="psychology-session-products-title-wrapper">
          <h1 className="psychology-session-products-title">{title}</h1>
          <p className="psychology-session-products-subtitle">{parse(subtitle || "")}</p>
        </div>

        <div className="psychology-session-products-pricing">
          <CardProduct price={price} linkTo={linkTo} onClickBuyButton={onClickBuyButton} />
          <div className="psychology-session-products-details">
            <Accordion
              data={[
                {
                  question: "¿En qué consiste el servicio de psicología?",
                  answer: `
                    <p>El servicio de psicología es un servicio online por sesiones de 55 minutos, individual o en pareja y privado, que te permite compartir aquello que necesites con nuestras psicólogas del equipo Vikika Team, profesionales con años de experiencia.</p>
                    <p>Nuestras psicólogas te brindarán todas las herramientas necesarias para mejorar día a día y encontrar el equilibrio. Algunos ejemplos de los temas que puedes tratar son:</p>
                    <ul>
                      <li>Autoconocimiento, cuidado y mejora de hábitos.</li>
                      <li>Cómo la alimentación y el entrenamiento puede afectar a las emociones.</li>
                      <li>Cómo la motivación afecta al día a día; encontrarla y aprender a mantenerla.</li>
                      <li>Recompensas y castigos autoimpuestos.</li>
                      <li>La importancia de reconocer, identificar y gestionar las emociones.</li>
                    </ul>
                    <p>Y mucho más…</p>
                    <p>Sean cuales sean tus preocupaciones, nuestras psicólogas estarán para atenderte en todo lo que necesites.</p>
                  `
                },
                {
                  question: "¿Cómo puedo realizar las sesiones de psicología?",
                  answer: `
                    <p>Para empezar, puedes reservar tu primera sesión en la cual te acompañaremos para poder empezar tu proceso de terapia online. Posteriormente podrás continuar reservando tus próximas sesiones eligiendo entre varias opciones:</p>
                    <p>
                      <ol>
                        <li>Suscripción de psicología.</li>
                        <li>Sesiones o bonos.</li>
                      </ol>
                    </p>
                    <p>Si quieres conocer la información completa sobre ello puedes acceder <a href="https://vikika.es/productos/psicologia" target="_blank" rel="noopener noreferrer">aquí</a>.
                    </p>
                  `
                },
                {
                  question: "¿Cómo empiezo y cuál es el proceso?",
                  answer: `
                  <p>Para poder realizar tu sesión con nuestras psicólogas del equipo Vikika Team, solo tienes que seguir estos sencillos pasos:</p>
                  <p>
                    <ol>
                      <li>Adquiere la sesión.</li>
                      <li>Envíanos por correo el consentimiento informado que recibirás con la confirmación de compra.</li>
                      <li>Una vez hayas enviado el consentimiento, te asignaremos una profesional del equipo de psicólogas de Vikika Team.</li>
                    </ol>
                  </p>
                  <p>A partir de este momento, podrás acceder a tu perfil y elegir la fecha y hora de tu primera sesión.</p>
                  `
                }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
